import {Component, Input, OnInit, signal, ViewEncapsulation} from '@angular/core';
import {CambioTitularReq, ProyectoItem} from "../../../../interfaces/proyecto.interface";
import {NgIf} from "@angular/common";
import {TagModule} from "primeng/tag";
import {AccordionModule} from "primeng/accordion";
import {TabViewModule} from "primeng/tabview";
import {TableModule} from "primeng/table";
import {TooltipModule} from "primeng/tooltip";
import {InputNumberModule} from "primeng/inputnumber";
import {PrimeNgModule} from "../../../../../shared/prime-ng/prime-ng.module";
import {parseTieneProyectoDefinido, parseToFormatNumber} from "../../../../../shared/services/utils-service";
import { AutorizacionesService } from 'src/app/officials/autorizaciones/services/autorizaciones.service';
import { LoginServices } from 'src/app/auth/login/services/login.service';
import { EditarTitularComponent } from './editar-titular/editar-titular.component';
import { Button } from 'primeng/button';
import { Autorizaciones } from 'src/app/officials/autorizaciones/interfaces/autorizaciones-interface';
import {DetalleConstruccionItemComponent} from "./detalle-construccion-item/detalle-construccion-item.component";
import Swal from 'sweetalert2';
import { ProyectoService } from '../../../services/proyecto.service';
import { TramiteEstadoEnum } from '../interface/ver-proyecto.interface';

@Component({
    selector: 'app-generales-proyecto',
    standalone: true,
    imports: [
        NgIf,
        TagModule,
        AccordionModule,
        TabViewModule,
        TableModule,
        TooltipModule,
        InputNumberModule,
        PrimeNgModule,
        EditarTitularComponent,
        Button,
        PrimeNgModule,
        DetalleConstruccionItemComponent
    ],
    templateUrl: './generales-proyecto.component.html',
    styleUrl: './generales-proyecto.component.scss',
    encapsulation: ViewEncapsulation.None
})
/**
 * Este componente es reutilizado en procesos de clientes y funcionarios.
 */

export class GeneralesProyectoComponent implements OnInit {



    /*===========================================================================================*/
    /*VARIABLES ---------------------------------------------------------------------------------*/
    /*===========================================================================================*/



    //PRIVATES ------------------------------------------------------------------------------------

    static RP: string = "RP_";
    private _prj: ProyectoItem | null = null;
    public is_ProyectoRegistroProfesional: boolean = false;

    @Input()
    set prj(data: ProyectoItem | null) {
        this._prj = data
        if (data) {
            //onChange detected
            this.is_ProyectoRegistroProfesional = this.isProyectoRegistroProfesional()
        }
    };

    get prj(): ProyectoItem | null {
        return this._prj
    }

    /**
     * Esta bandera controla si el componente muestra el título del proyecto.
     */
    @Input() rendertitle: boolean = false;
    protected readonly parseToFormatNumber = parseToFormatNumber;
    protected readonly parseTieneProyectoDefinido = parseTieneProyectoDefinido;
    /**
     * Con este input obtendremos un booleano que nos indicara si realmente es o no es
     * de la categoria de registro profesional, ya que se requiere ocultar algunos
     * elementos que coincidan
     */
    @Input() isRegistroProfesional: boolean = false;
    /**
     * Con este input obtendremos un booleano que nos indicara si realmente se debe o no
     * mostrar el titulo del componente
     */
    @Input() hideTitle: boolean = false
    /**
     * Con este input obtendremos un booleano que nos indicara si realmente se debe o no
     * mostrar la descripcion del componente
     */
    @Input() hideDescription: boolean = false;
    @Input() proyectoPagado: boolean = true;

    mostrarCambiarTitularBoton = signal(false);
    mostrarEditarTitularDialog = signal(false);
    titulares: {nombreCompleto: string, uniqueId: string}[] = [];
    uniqueIdTitularActual: string = "";
    constructor(protected autorizacionesService: AutorizacionesService, protected loginServices: LoginServices, public proyectoService: ProyectoService){}

    ngOnInit(): void {
        this.autorizacionesService.consultaAutorizaciones(this.loginServices.session()?.perfil?.uniqueId!, [1])
            .subscribe(resp => {
                if (resp) {
                    this.autorizacionesService._autorizacionesPersona.set(resp!.body!);
                    if(resp.body?.length !== undefined && resp.body?.length > 0) {
                        this.mostrarCambiarTitularBoton.set(true);
                        this.titulares = resp.body.map(titular => {
                            return {
                                nombreCompleto: `${titular.nombres} ${titular.apellidos}`.trim(),
                                uniqueId: titular.uniqueId
                            }
                        })
                        this.uniqueIdTitularActual = this._prj!.titular.uniqueId;
                    }
                }
            });
    }

    onAbrirEditarTitularDialog() {
        this.mostrarEditarTitularDialog.set(true);
    }

    onCerrarEditarTitularDialog() {
        this.mostrarEditarTitularDialog.set(false);
    }

    onConfirmEditarTitularDialog(selectedUniqueId: string) {
        if(!(this.uniqueIdTitularActual !== selectedUniqueId)) return;

        const payloadCambioTitular: CambioTitularReq = {
            idProyecto: this._prj!.idProyecto.toString(),
            idTitular: selectedUniqueId,
            session: {
                uniqueId: this.loginServices.session()?.perfil.uniqueId,
                correo: this.loginServices.session()?.perfil.correo,
                usuario: this.loginServices.session()?.perfil.usuario!,
                documento: this.loginServices.session()?.perfil.documento,
            }
        }

        this.proyectoService.cambioTitular(payloadCambioTitular).subscribe({
            next: (res) => {
                if (res.status === 200 || res.status === 201) {
                    const nuevoTitular = this.titulares.find(titular => titular.uniqueId === selectedUniqueId);

                    this._prj!.titular = {
                        uniqueId: nuevoTitular!.uniqueId,
                        nombreCompleto: nuevoTitular!.nombreCompleto,
                        usuario: ""
                    }

                    this.uniqueIdTitularActual = nuevoTitular!.uniqueId;
                    this.mostrarEditarTitularDialog.set(false);
                    
                    Swal.fire({
                        title: "Titular cambiado correctamente",
                        icon: 'success'
                    })
                }
            }, error: (err) => {
                Swal.fire({
                    title: "Error",
                    text: err.error.mensaje,
                    icon: "error"
                });
                return;
            }
        })
        

        
    }

    /*===========================================================================================*/
    /*METHODS -----------------------------------------------------------------------------------*/
    /*===========================================================================================*/



    /*===========================================================================================*/
    /*UTILS -------------------------------------------------------------------------------------*/
    /*===========================================================================================*/


    isProyectoRegistroProfesional(): boolean {
        return this.prj?.nombre.startsWith(GeneralesProyectoComponent.RP) || false;
    }
}
